// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!../../node_modules/antd/dist/antd.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  outline: 0 !important;
}

h1,
h2 {
  margin: 0 !important;
}

body {
  font-family: "Roboto";
}

.container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-self: center;
}

.app-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: center;
}

.app-content {
  display: flex;
  padding: 60px 90px !important;
  box-sizing: border-box;
  flex-direction: column;
  align-self: center;
  min-height: 52.5vh;
  width: 100% !important;
}

.footer-and-header-padding {
  padding-left: calc(12.5% + 90px) !important;
  padding-right: calc(12.5% + 90px) !important;
}

.page-content {
  display: flex;
  justify-content: center;
}

.ant-btn:hover,
.ant-btn:focus {
  color: #008241 !important;
  border-color: #008241 !important;
}

.button-container-direction-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 25px;
}

.primary-button,
.secondary-button,
.link-button {
  min-height: 40px !important;
  box-sizing: border-box;
  font-size: 16px !important;
}

.primary-button {
  min-width: 170px;
  text-transform: uppercase;
  border: none;
  border-radius: 50px !important;
  font-weight: bold;
  background-color: #00a84a;
  color: #fff;
}
.primary-button:hover, .primary-button:focus {
  color: #fff !important;
  background: #008241 !important;
  border: solid 1px #00a84a !important;
}
.primary-button:disabled {
  color: #b7b7b7 !important;
  background: #f5f5f5 !important;
  border: solid 1px #b7b7b7 !important;
}
@media (max-width: 768px) {
  .primary-button {
    min-height: 25px !important;
  }
}

.secondary-button {
  min-width: 160px;
  text-transform: uppercase;
  border: solid 1px #00a84a;
  border-radius: 50px !important;
  font-weight: bold;
  background-color: #fff;
  color: #00a84a;
}
.secondary-button:hover, .secondary-button:focus {
  background: #fff !important;
  color: #008241 !important;
  border: solid 2px #008241 !important;
}
@media (max-width: 768px) {
  .secondary-button {
    min-height: 25px !important;
  }
}

.link-button {
  min-width: 160px;
  background: #fff;
  color: #00a84a !important;
  border-radius: 50px !important;
  border: none;
  box-shadow: none;
  text-shadow: none;
  font-weight: bold;
}
.link-button:hover, .link-button:active, .link-button:focus {
  color: #008241 !important;
}

.large-button {
  width: 390px;
}

.button-back {
  box-shadow: none;
  border: none;
  background-color: transparent;
  color: #36a6ff;
  padding: 0;
}

.button-back:hover {
  border: none;
  background-color: transparent;
  color: #36a6ff;
}

.box-style-with-border,
.box-style-with-border-and-padding {
  border-radius: 16px !important;
  overflow: hidden !important;
  border: 1px solid #d6d6d6 !important;
}

.box-style-with-border-and-padding {
  padding: 24px;
}

.card-style-with-border,
.card-style-with-border-and-padding {
  border-radius: 30px !important;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1019607843);
}

.card-style-with-border-and-padding {
  padding: 24px;
}
@media (max-width: 768px) {
  .card-style-with-border-and-padding {
    padding: 15px !important;
    border-radius: 20px !important;
  }
}

.edit-button {
  color: #00a84a !important;
  border-color: #00a84a !important;
  background-color: transparent !important;
}
.edit-button:hover {
  color: #fff !important;
  border-color: #fff !important;
  background-color: #00a84a !important;
}

.delete-button {
  color: #db3236 !important;
  border-color: #db3236 !important;
  background-color: transparent !important;
}
.delete-button:hover {
  color: #fff !important;
  border-color: #fff !important;
  background-color: #db3236 !important;
}

.button-small {
  font-size: 16px;
  height: 32px;
  width: 25%;
  padding: 8px 10px !important;
}

.loading-container {
  text-align: center;
  margin-top: 20px;
}

@media (max-width: 1600px) {
  .app-content {
    width: 80%;
  }
  .footer-and-header-padding {
    padding-left: 10% !important;
    padding-right: 10% !important;
  }
}
@media (max-width: 1400px) {
  .app-content {
    width: 90%;
  }
}
@media (max-width: 1000px) {
  .app-content {
    width: 100%;
  }
  .footer-and-header-padding {
    padding-left: 90px !important;
    padding-right: 90px !important;
  }
}
@media (max-width: 800px) {
  .app-container {
    padding-bottom: 20px;
  }
  .app-content {
    padding: 20px !important;
  }
  .app-content form {
    width: 100%;
  }
  .footer-and-header-padding {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}
.ant-spin-dot-item {
  background-color: #00a84a;
}

.manager-header {
  display: flex;
  justify-content: space-between;
}
.manager-header .icon-table {
  font-size: 42px;
  margin-right: 10px;
  margin-bottom: 20px;
  color: #50b570 !important;
}

.no-margin {
  margin: 0 !important;
}

.new-style-table .ant-table-row-cell-break-word {
  padding: 0 !important;
}
.new-style-table .action-column {
  display: none;
}
.new-style-table .action-column button {
  margin-left: 5px;
}
.new-style-table .ant-table-row:hover .action-column {
  display: flex;
}
.new-style-table .ant-table-row {
  cursor: pointer;
}
.new-style-table .icon-table {
  font-size: 42px;
  margin-right: 10px;
  margin-bottom: 20px;
  color: #50b570 !important;
}

.ant-input,
.ant-picker,
.ant-select .ant-select-selector,
.ant-input-affix-wrapper {
  box-shadow: #ff0000;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-color: #485156 !important;
  background-color: transparent !important;
}

.ant-input:focus,
.ant-input-focused,
.ant-select:focus,
.ant-select-focused,
.ant-input-number:focus,
.ant-input-number-focused,
.ant-input-affix-wrapper:focus,
.ant-input-affix-wrapper-focused,
.ant-picker:focus,
.ant-picker-focused {
  box-shadow: 0 0 0 2px rgba(0, 168, 74, 0.2) !important;
  border-radius: 2px;
}

.ant-input-number:focus,
.ant-input-number-focused {
  border: none;
}

.ant-input-number:hover {
  box-shadow: 0 0 0 2px rgba(0, 168, 74, 0.2) !important;
  border: none;
}

.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  box-shadow: none;
}

.ant-select span,
.ant-picker span {
  color: #637178 !important;
  opacity: 1;
}

.ant-picker-input input {
  color: #637178 !important;
}
.ant-picker-input ::placeholder {
  color: #637178;
  opacity: 1;
}
.ant-picker-input :-ms-input-placeholder {
  color: #637178;
}
.ant-picker-input ::-ms-input-placeholder {
  color: #637178;
}

.ant-form-item-control-input {
  min-height: 0;
}

.form-dynamic .ant-form-item {
  margin-bottom: 10px;
  width: 100%;
}
.form-dynamic .ant-form-item-control-input {
  display: block !important;
}
.form-dynamic .ant-form-item-control-input .ant-form-item-control-input-content {
  display: flex;
}
.form-dynamic .ant-form-item-control-input .ant-form-item-control-input-content input {
  margin-left: 10px;
}

.document {
  margin-bottom: 24px;
  text-align: left;
}
.document h2 {
  color: #000 !important;
}
.document h3 {
  font-size: 14px;
}
.document h3 .required-field {
  color: #f5222d;
  font-size: 14px;
  margin-right: 4px;
  line-height: 1;
  font-family: SimSun, sans-serif;
  content: "*";
}

.ant-form-item {
  margin-bottom: 5px;
}
.ant-form-item label {
  margin-top: 15px !important;
  color: #000 !important;
  font-weight: 500 !important;
  font-size: 14px;
}
.ant-form-item label .required-field {
  color: #f5222d;
  font-size: 14px;
  margin-right: 4px;
  line-height: 1;
  font-family: SimSun, sans-serif;
  content: "*";
}
.ant-form-item input {
  background-color: transparent;
}
.ant-form-item ::placeholder {
  color: #637178;
  opacity: 1;
}
.ant-form-item :-ms-input-placeholder {
  color: #637178;
}
.ant-form-item ::-ms-input-placeholder {
  color: #637178;
}

.document-form {
  text-align: left;
  background-color: #f9f9f9;
  border-radius: 15px;
  padding: 15px 12px;
}
.document-form h3 {
  margin-top: 15px !important;
  color: #000 !important;
  font-weight: 500 !important;
}
.document-form h3:first-child {
  margin-top: 0px !important;
}
.document-form div {
  margin-bottom: 0px;
}

.file-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.file-content .ant-form-item {
  margin: 0 !important;
}

.filter {
  width: 100%;
  margin-bottom: 30px !important;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.filter .search-input {
  width: 40% !important;
}
.filter .search-input input {
  height: 45px;
  border-radius: 6px !important;
}
.filter .search-input input:focus {
  --webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.filter .search-input input::placeholder {
  color: #485156;
}
.filter .search-input span.ant-input-wrapper.ant-input-group {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}
.filter .search-input .ant-input-group .ant-input {
  padding-left: 40px;
  float: left;
  width: 100%;
  margin-bottom: 0;
  z-index: 0;
  text-align: inherit;
  background: #f1f3f4 0% 0% no-repeat padding-box !important;
  border: none !important;
}
.filter .search-input button.ant-btn.ant-btn-icon-only.ant-input-search-button {
  background: transparent;
  border: none;
}
.filter .search-input span.anticon.anticon-search {
  color: #485156;
  padding-left: 10px;
}

.ant-spin-dot-item {
  background-color: #ffbd00 !important;
}

.ant-form-item-required:before {
  display: none !important;
}

.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
  display: inline-block;
  margin-left: 4px;
  color: #ff0000;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}

.required-field-with-popover .ant-form-item-required::after {
  display: none !important;
}
.required-field-with-popover .required {
  margin-left: -10px;
}

.ant-modal-body {
  overflow: hidden;
}

.ant-radio:hover .ant-radio-inner {
  border-color: #00a84a !important;
}

.ant-radio-checked .ant-radio-inner,
.ant-radio-checked::after,
.ant-checkbox-checked .ant-checkbox-inner {
  color: #00a84a !important;
  border-color: #00a84a !important;
}

.ant-radio-checked .ant-radio-inner::after,
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #00a84a !important;
}

.ant-radio:hover .ant-radio-inner {
  border-color: #00a84a !important;
}

.ant-radio-input:focus + .ant-radio-inner {
  box-shadow: none !important;
}

.ant-radio-wrapper:hover .ant-radio,
.ant-radio:hover .ant-radio-inner,
.ant-radio-input:focus + .ant-radio-inner {
  border-color: #00a84a !important;
}

.ant-modal-content {
  border-radius: 20px;
}
.ant-modal-content .ant-modal-header {
  border: none !important;
  background-color: transparent !important;
}
.ant-modal-content .ant-modal-footer {
  display: flex;
  border: none !important;
  justify-content: center;
}

.ant-modal-content .ant-modal-body .ant-switch:focus {
  color: #00a84a;
  border-color: #00a84a;
}
.ant-modal-content .ant-modal-body .ant-btn-primary {
  background-color: #00a84a;
  border-color: #00a84a;
  color: #ffffff !important;
}
.ant-modal-content .ant-modal-body .ant-btn-primary:disabled {
  color: #b7b7b7 !important;
  background: #f5f5f5 !important;
  border: solid 1px #b7b7b7 !important;
}
.ant-modal-content .ant-modal-body .ant-btn-primary:hover {
  color: #ffffff;
  background-color: #008241;
  border-color: #008241;
}

.ant-modal-footer .ant-btn.ant-btn-primary {
  color: #ffffff;
  background-color: #00a84a;
  border-color: #00a84a;
}
.ant-modal-footer .ant-btn.ant-btn-primary:hover {
  background-color: #008241;
  border-color: #008241;
  color: #ffffff;
}
.ant-modal-footer .ant-btn.ant-btn-primary:focus {
  color: #ffffff;
}

.ant-menu-vertical {
  border-right: none;
}

.ant-pagination .ant-pagination-item-active,
.ant-pagination .ant-pagination-item-active a,
.ant-pagination .ant-pagination-item:hover,
.ant-pagination .ant-pagination-item a:hover,
.ant-pagination .ant-pagination-item-link:enabled:hover,
.ant-pagination .ant-pagination-item-container:hover .anticon {
  color: #00a84a;
  border-color: #00a84a;
}

.ant-picker-range .ant-picker-active-bar {
  background: transparent !important;
}

.ant-picker-dropdown .ant-picker-cell-today .ant-picker-cell-inner::before {
  border-color: #00a84a;
}
.ant-picker-dropdown .ant-picker-year-btn:hover,
.ant-picker-dropdown .ant-picker-month-btn:hover {
  color: #00a84a;
}
.ant-picker-dropdown .ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: #00a84a;
}
.ant-picker-dropdown .ant-picker-footer .ant-picker-now-btn {
  color: #00a84a;
}
.ant-picker-dropdown .ant-picker-footer .ant-btn-primary {
  color: #ffffff;
  background-color: #00a84a;
  border-color: #00a84a;
}
.ant-picker-dropdown .ant-picker-footer .ant-btn-primary:hover {
  background-color: #008241;
  border-color: #008241;
}

.finish-button {
  display: flex;
  justify-content: flex-end;
}
.finish-button .ant-btn-primary,
.finish-button .ant-btn {
  background-color: #00a84a;
  border-color: #00a84a;
  color: #ffffff;
  padding: 10px 30px;
  border-radius: 5px;
  height: auto !important;
  transition: all 100ms ease-in-out;
  font-weight: bold;
}
.finish-button .ant-btn-primary:hover,
.finish-button .ant-btn:hover {
  background-color: #008241 !important;
  border-color: #008241 !important;
  color: #ffffff !important;
}

.upload-container {
  max-height: 45px !important;
}
.upload-container .ant-upload-span,
.upload-container .upload-button {
  height: 40px !important;
  margin: 10px 0 !important;
  border-radius: 50px !important;
  font-weight: bold;
  font-size: 16px !important;
  color: #00a84a !important;
  border-color: #00a84a !important;
  display: flex;
  align-items: center;
}
.upload-container .ant-upload-span span,
.upload-container .upload-button span {
  margin-left: 2px !important;
}
.upload-container .ant-upload-span span svg,
.upload-container .upload-button span svg {
  font-size: 20px !important;
}
.upload-container .ant-upload-span {
  background-color: #ffffff;
  padding: 0 15px !important;
  max-height: 40px !important;
  max-width: 200px !important;
  border: 1px solid #00a84a;
  overflow: hidden !important;
}
.upload-container .ant-upload-span svg {
  color: #00a84a;
}
.upload-container .ant-upload-list-item {
  height: 45px !important;
  margin: 0 !important;
}
.upload-container .ant-upload-list-item .ant-upload-text-icon {
  width: 20px;
  height: 23px;
}
.upload-container .ant-upload-list-item .ant-upload-list-item-info {
  padding: 0 !important;
}
.upload-container .ant-upload-list-item .ant-upload-list-item-info:hover {
  background-color: transparent;
}
.upload-container .ant-upload-list-item .ant-upload-list-item-info .ant-upload-list-item-name {
  color: #00a84a !important;
  padding: 0 !important;
  margin: 0 5px !important;
}
.upload-container .ant-upload-list-item .ant-upload-list-item-info .ant-upload-list-item-name:hover {
  cursor: pointer;
  text-decoration: underline;
}
.upload-container .ant-upload-list-item .ant-upload-list-item-info .ant-upload-list-item-card-actions-btn,
.upload-container .ant-upload-list-item .ant-upload-list-item-info .ant-upload-list-item-card-actions {
  opacity: 1 !important;
}
.upload-container .ant-upload-list-item .ant-upload-list-item-info .ant-upload-list-item-card-actions-btn svg,
.upload-container .ant-upload-list-item .ant-upload-list-item-info .ant-upload-list-item-card-actions svg {
  font-size: 16px !important;
}
.upload-container .ant-upload-list-item .ant-upload-list-item-info .anticon-close {
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
  opacity: 1 !important;
}
.upload-container .ant-upload-disabled .upload-button {
  cursor: not-allowed;
  color: #e9e9e9 !important;
  border-color: #e9e9e9 !important;
}
.upload-container .ant-upload-disabled .upload-button svg {
  color: #e9e9e9 !important;
}

.ant-tabs-top > .ant-tabs-nav::before {
  border-bottom: none !important;
}

.ant-pagination {
  display: flex !important;
  justify-content: flex-start !important;
  margin-top: 15px !important;
}
.ant-pagination .ant-select-selector,
.ant-pagination .ant-pagination-item,
.ant-pagination .ant-pagination-item-link {
  border-radius: 5px !important;
}
.ant-pagination .ant-select-selector {
  border: 1px solid #d9d9d9 !important;
}

.ant-modal-title {
  font-size: 20px !important;
}

.ant-form-item-explain-error {
  color: #ff4d4f !important;
}

.ant-table-tbody > tr.ant-table-row-selected > td,
.ant-table-tbody > tr.ant-table-row:hover > td,
.ant-table-tbody > tr > td.ant-table-cell-row-hover {
  background-color: rgba(0, 130, 65, 0.0745098039) !important;
  cursor: pointer;
}

.ant-checkbox-input:focus + .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-inner {
  border-color: #00a84a !important;
}

.ant-checkbox-checked::after {
  border-color: rgba(0, 130, 65, 0.4862745098) !important;
}

.ant-notification {
  z-index: 9999999999 !important;
}

.ant-row {
  flex-flow: column !important;
}

.ant-form-horizontal .ant-form-item-label {
  text-align: left;
}

.ant-switch-checked {
  background-color: #00a84a !important;
  transition: color 0.8, border 0.8;
}
.ant-switch-checked:hover {
  color: #10a574;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAIA;EACE,sBAAA;EACA,qBAAA;AADF;;AAIA;;EAEE,oBAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AADF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AADF;;AAIA;EACE,2CAAA;EACA,4CAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;AADF;;AAIA;;EAEE,yBAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AADF;;AAIA;;;EAGE,2BAAA;EACA,sBAAA;EACA,0BAAA;AADF;;AAIA;EACE,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,yBC9Ec;ED+Ed,WAAA;AADF;AAGE;EAEE,sBAAA;EACA,8BAAA;EACA,oCAAA;AAFJ;AAKE;EACE,yBAAA;EACA,8BAAA;EACA,oCAAA;AAHJ;AAME;EAtBF;IAuBI,2BAAA;EAHF;AACF;;AAMA;EACE,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,8BAAA;EACA,iBAAA;EACA,sBAAA;EACA,cC1Gc;ADuGhB;AAKE;EAEE,2BAAA;EACA,yBAAA;EACA,oCAAA;AAJJ;AAOE;EAhBF;IAiBI,2BAAA;EAJF;AACF;;AAOA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAJF;AAME;EAGE,yBAAA;AANJ;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,gBAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,UAAA;AAPF;;AAUA;EACE,YAAA;EACA,6BAAA;EACA,cAAA;AAPF;;AAUA;;EAEE,8BAAA;EACA,2BAAA;EACA,oCAAA;AAPF;;AAUA;EACE,aAAA;AAPF;;AAUA;;EAEE,8BAAA;EACA,oDAAA;AAPF;;AAWA;EACE,aAAA;AARF;AAUE;EAHF;IAII,wBAAA;IACA,8BAAA;EAPF;AACF;;AAUA;EACE,yBAAA;EACA,gCAAA;EACA,wCAAA;AAPF;AASE;EACE,sBAAA;EACA,6BAAA;EACA,oCAAA;AAPJ;;AAWA;EACE,yBAAA;EACA,gCAAA;EACA,wCAAA;AARF;AAUE;EACE,sBAAA;EACA,6BAAA;EACA,oCAAA;AARJ;;AAYA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,4BAAA;AATF;;AAYA;EACE,kBAAA;EACA,gBAAA;AATF;;AAYA;EACE;IACE,UAAA;EATF;EAYA;IACE,4BAAA;IACA,6BAAA;EAVF;AACF;AAaA;EACE;IACE,UAAA;EAXF;AACF;AAcA;EACE;IACE,WAAA;EAZF;EAeA;IACE,6BAAA;IACA,8BAAA;EAbF;AACF;AAgBA;EACE;IACE,oBAAA;EAdF;EAiBA;IACE,wBAAA;EAfF;EAiBE;IACE,WAAA;EAfJ;EAmBA;IACE,6BAAA;IACA,8BAAA;EAjBF;AACF;AAoBA;EACE,yBC1Qc;ADwPhB;;AAqBA;EACE,aAAA;EACA,8BAAA;AAlBF;AAoBE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAlBJ;;AAsBA;EACE,oBAAA;AAnBF;;AAuBE;EACE,qBAAA;AApBJ;AAuBE;EACE,aAAA;AArBJ;AAuBI;EACE,gBAAA;AArBN;AAyBE;EACE,aAAA;AAvBJ;AA0BE;EACE,eAAA;AAxBJ;AA2BE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAzBJ;;AA6BA;;;;EAIE,mBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,gCAAA;EACA,wCAAA;AA1BF;;AA6BA;;;;;;;;;;EAUE,sDAAA;EACA,kBAAA;AA1BF;;AA6BA;;EAEE,YAAA;AA1BF;;AA6BA;EACE,sDAAA;EACA,YAAA;AA1BF;;AA6BA;EAIE,gBAAA;AA7BF;;AAkCE;;EACE,yBAAA;EACA,UAAA;AA9BJ;;AAmCE;EACE,yBAAA;AAhCJ;AAmCE;EACE,cAAA;EACA,UAAA;AAjCJ;AAoCE;EACE,cAAA;AAlCJ;AAqCE;EACE,cAAA;AAnCJ;;AAuCA;EACE,aAAA;AApCF;;AAwCE;EACE,mBAAA;EACA,WAAA;AArCJ;AAwCE;EACE,yBAAA;AAtCJ;AAwCI;EACE,aAAA;AAtCN;AAwCM;EACE,iBAAA;AAtCR;;AA4CA;EACE,mBAAA;EACA,gBAAA;AAzCF;AA2CE;EACE,sBAAA;AAzCJ;AA4CE;EACE,eAAA;AA1CJ;AA4CI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAAA;EACA,YAAA;AA1CN;;AA+CA;EACE,kBAAA;AA5CF;AA8CE;EACE,2BAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;AA5CJ;AA8CI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAAA;EACA,YAAA;AA5CN;AAgDE;EACE,6BAAA;AA9CJ;AAiDE;EACE,cAAA;EACA,UAAA;AA/CJ;AAkDE;EACE,cAAA;AAhDJ;AAmDE;EACE,cAAA;AAjDJ;;AAqDA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAlDF;AAoDE;EACE,2BAAA;EACA,sBAAA;EACA,2BAAA;AAlDJ;AAqDE;EACE,0BAAA;AAnDJ;AAsDE;EACE,kBAAA;AApDJ;;AAwDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AArDF;AAuDE;EACE,oBAAA;AArDJ;;AAyDA;EACE,WAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAtDF;AAwDE;EACE,qBAAA;AAtDJ;AAwDI;EACE,YAAA;EACA,6BAAA;AAtDN;AAwDM;EACE,oCAAA;EACA,2BAAA;AAtDR;AA0DI;EACE,cAAA;AAxDN;AA2DI;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AAzDN;AA4DI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,0DAAA;EACA,uBAAA;AA1DN;AA6DI;EACE,uBAAA;EACA,YAAA;AA3DN;AA8DI;EACE,cAAA;EACA,kBAAA;AA5DN;;AAiEA;EACE,oCAAA;AA9DF;;AAiEA;EACE,wBAAA;AA9DF;;AAiEA;EAIE,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,YAAA;AAjEF;;AAqEE;EACE,wBAAA;AAlEJ;AAqEE;EACE,kBAAA;AAnEJ;;AAuEA;EACE,gBAAA;AApEF;;AAsEA;EACE,gCAAA;AAnEF;;AAsEA;;;EAGE,yBAAA;EACA,gCAAA;AAnEF;;AAsEA;;EAEE,oCAAA;AAnEF;;AAsEA;EACE,gCAAA;AAnEF;;AAsEA;EACE,2BAAA;AAnEF;;AAsEA;;;EAGE,gCAAA;AAnEF;;AAsEA;EACE,mBAAA;AAnEF;AAqEE;EACE,uBAAA;EACA,wCAAA;AAnEJ;AAsEE;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;AApEJ;;AAyEE;EACE,cCznBY;ED0nBZ,qBC1nBY;ADojBhB;AAyEE;EACE,yBC9nBY;ED+nBZ,qBC/nBY;EDgoBZ,yBAAA;AAvEJ;AAyEI;EACE,yBAAA;EACA,8BAAA;EACA,oCAAA;AAvEN;AA2EE;EACE,cAAA;EACA,yBCvoBY;EDwoBZ,qBCxoBY;AD+jBhB;;AA8EE;EACE,cAAA;EACA,yBCnpBY;EDopBZ,qBCppBY;ADykBhB;AA8EE;EACE,yBCppBY;EDqpBZ,qBCrpBY;EDspBZ,cAAA;AA5EJ;AA+EE;EACE,cAAA;AA7EJ;;AAiFA;EACE,kBAAA;AA9EF;;AAkFE;;;;;;EAME,cC7qBY;ED8qBZ,qBC9qBY;AD+lBhB;;AAmFA;EACE,kCAAA;AAhFF;;AAoFE;EACE,qBCxrBY;ADumBhB;AAoFE;;EAEE,cC7rBY;AD2mBhB;AAqFE;EACE,yBCjsBY;AD8mBhB;AAuFI;EACE,cCtsBU;ADinBhB;AAwFI;EACE,cAAA;EACA,yBC3sBU;ED4sBV,qBC5sBU;ADsnBhB;AAyFI;EACE,yBC5sBU;ED6sBV,qBC7sBU;ADsnBhB;;AA4FA;EACE,aAAA;EACA,yBAAA;AAzFF;AA2FE;;EAEE,yBC5tBY;ED6tBZ,qBC7tBY;ED8tBZ,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iCAAA;EACA,iBAAA;AAzFJ;AA4FE;;EAEE,oCAAA;EACA,gCAAA;EACA,yBAAA;AA1FJ;;AA8FA;EACE,2BAAA;AA3FF;AA6FE;;EAEE,uBAAA;EACA,yBAAA;EACA,8BAAA;EACA,iBAAA;EACA,0BAAA;EACA,yBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;AA3FJ;AA6FI;;EACE,2BAAA;AA1FN;AA4FM;;EACE,0BAAA;AAzFR;AA8FE;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,2BAAA;AA5FJ;AA6FI;EACE,cC9wBU;ADmrBhB;AA+FE;EACE,uBAAA;EACA,oBAAA;AA7FJ;AA+FI;EACE,WAAA;EACA,YAAA;AA7FN;AAgGI;EACE,qBAAA;AA9FN;AAgGM;EACE,6BAAA;AA9FR;AAiGM;EACE,yBAAA;EACA,qBAAA;EACA,wBAAA;AA/FR;AAiGQ;EACE,eAAA;EACA,0BAAA;AA/FV;AAmGM;;EAEE,qBAAA;AAjGR;AAmGQ;;EACE,0BAAA;AAhGV;AAoGM;EACE,6BAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AAlGR;AAwGI;EACE,mBAAA;EACA,yBAAA;EACA,gCAAA;AAtGN;AAwGM;EACE,yBAAA;AAtGR;;AA4GA;EACE,8BAAA;AAzGF;;AA4GA;EACE,wBAAA;EACA,sCAAA;EACA,2BAAA;AAzGF;AA2GE;;;EAGE,6BAAA;AAzGJ;AA4GE;EACE,oCAAA;AA1GJ;;AA8GA;EACE,0BAAA;AA3GF;;AA8GA;EACE,yBAAA;AA3GF;;AA8GA;;;EAGE,2DAAA;EACA,eAAA;AA3GF;;AA8GA;;;EAGE,gCAAA;AA3GF;;AA8GA;EACE,uDAAA;AA3GF;;AA8GA;EACE,8BAAA;AA3GF;;AA8GA;EACE,4BAAA;AA3GF;;AA8GA;EACE,gBAAA;AA3GF;;AA8GA;EACE,oCAAA;EACA,iCAAA;AA3GF;AA4GE;EACE,cCv4Ba;AD6xBjB","sourcesContent":["@import '~antd/dist/antd.css';\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');\n@import 'colors.scss';\n\n* {\n  box-sizing: border-box;\n  outline: 0 !important;\n}\n\nh1,\nh2 {\n  margin: 0 !important;\n}\n\nbody {\n  font-family: 'Roboto';\n}\n\n.container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n}\n\n.app-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-self: center;\n}\n\n.app-content {\n  display: flex;\n  padding: 60px 90px !important;\n  box-sizing: border-box;\n  flex-direction: column;\n  align-self: center;\n  min-height: 52.5vh;\n  width: 100% !important;\n}\n\n.footer-and-header-padding {\n  padding-left: calc(12.5% + 90px) !important;\n  padding-right: calc(12.5% + 90px) !important;\n}\n\n.page-content {\n  display: flex;\n  justify-content: center;\n}\n\n.ant-btn:hover,\n.ant-btn:focus {\n  color: $hover-primary !important;\n  border-color: $hover-primary !important;\n}\n\n.button-container-direction-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 25px;\n}\n\n.primary-button,\n.secondary-button,\n.link-button {\n  min-height: 40px !important;\n  box-sizing: border-box;\n  font-size: 16px !important;\n}\n\n.primary-button {\n  min-width: 170px;\n  text-transform: uppercase;\n  border: none;\n  border-radius: 50px !important;\n  font-weight: bold;\n  background-color: $primary-color;\n  color: #fff;\n\n  &:hover,\n  &:focus {\n    color: #fff !important;\n    background: $hover-primary !important;\n    border: solid 1px $primary-color !important;\n  }\n\n  &:disabled {\n    color: $inactive-button !important;\n    background: #f5f5f5 !important;\n    border: solid 1px $inactive-button !important;\n  }\n\n  @media (max-width: 768px) {\n    min-height: 25px !important;\n  }\n}\n\n.secondary-button {\n  min-width: 160px;\n  text-transform: uppercase;\n  border: solid 1px $primary-color;\n  border-radius: 50px !important;\n  font-weight: bold;\n  background-color: #fff;\n  color: $primary-color;\n\n  &:hover,\n  &:focus {\n    background: #fff !important;\n    color: $hover-primary !important;\n    border: solid 2px $hover-primary !important;\n  }\n\n  @media (max-width: 768px) {\n    min-height: 25px !important;\n  }\n}\n\n.link-button {\n  min-width: 160px;\n  background: #fff;\n  color: $primary-color !important;\n  border-radius: 50px !important;\n  border: none;\n  box-shadow: none;\n  text-shadow: none;\n  font-weight: bold;\n\n  &:hover,\n  &:active,\n  &:focus {\n    color: $hover-primary !important;\n  }\n}\n\n.large-button {\n  width: 390px;\n}\n\n.button-back {\n  box-shadow: none;\n  border: none;\n  background-color: transparent;\n  color: #36a6ff;\n  padding: 0;\n}\n\n.button-back:hover {\n  border: none;\n  background-color: transparent;\n  color: #36a6ff;\n}\n\n.box-style-with-border,\n.box-style-with-border-and-padding {\n  border-radius: 16px !important;\n  overflow: hidden !important;\n  border: 1px solid #d6d6d6 !important;\n}\n\n.box-style-with-border-and-padding {\n  padding: 24px;\n}\n\n.card-style-with-border,\n.card-style-with-border-and-padding {\n  border-radius: 30px !important;\n  box-shadow: 0px 2px 10px #0000001a;\n  // border: 1.5px solid #e5e7ec !important;\n}\n\n.card-style-with-border-and-padding {\n  padding: 24px;\n\n  @media (max-width: 768px) {\n    padding: 15px !important;\n    border-radius: 20px !important;\n  }\n}\n\n.edit-button {\n  color: $primary-color !important;\n  border-color: $primary-color !important;\n  background-color: transparent !important;\n\n  &:hover {\n    color: #fff !important;\n    border-color: #fff !important;\n    background-color: $primary-color !important;\n  }\n}\n\n.delete-button {\n  color: $status-invalid !important;\n  border-color: $status-invalid !important;\n  background-color: transparent !important;\n\n  &:hover {\n    color: #fff !important;\n    border-color: #fff !important;\n    background-color: $status-invalid !important;\n  }\n}\n\n.button-small {\n  font-size: 16px;\n  height: 32px;\n  width: 25%;\n  padding: 8px 10px !important;\n}\n\n.loading-container {\n  text-align: center;\n  margin-top: 20px;\n}\n\n@media (max-width: 1600px) {\n  .app-content {\n    width: 80%;\n  }\n\n  .footer-and-header-padding {\n    padding-left: 10% !important;\n    padding-right: 10% !important;\n  }\n}\n\n@media (max-width: 1400px) {\n  .app-content {\n    width: 90%;\n  }\n}\n\n@media (max-width: 1000px) {\n  .app-content {\n    width: 100%;\n  }\n\n  .footer-and-header-padding {\n    padding-left: 90px !important;\n    padding-right: 90px !important;\n  }\n}\n\n@media (max-width: 800px) {\n  .app-container {\n    padding-bottom: 20px;\n  }\n\n  .app-content {\n    padding: 20px !important;\n\n    form {\n      width: 100%;\n    }\n  }\n\n  .footer-and-header-padding {\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  }\n}\n\n.ant-spin-dot-item {\n  background-color: $primary-color;\n}\n\n.manager-header {\n  display: flex;\n  justify-content: space-between;\n\n  .icon-table {\n    font-size: 42px;\n    margin-right: 10px;\n    margin-bottom: 20px;\n    color: $secondary-color !important;\n  }\n}\n\n.no-margin {\n  margin: 0 !important;\n}\n\n.new-style-table {\n  .ant-table-row-cell-break-word {\n    padding: 0 !important;\n  }\n\n  .action-column {\n    display: none;\n\n    button {\n      margin-left: 5px;\n    }\n  }\n\n  .ant-table-row:hover .action-column {\n    display: flex;\n  }\n\n  .ant-table-row {\n    cursor: pointer;\n  }\n\n  .icon-table {\n    font-size: 42px;\n    margin-right: 10px;\n    margin-bottom: 20px;\n    color: $secondary-color !important;\n  }\n}\n\n.ant-input,\n.ant-picker,\n.ant-select .ant-select-selector,\n.ant-input-affix-wrapper {\n  box-shadow: #ff0000;\n  border-top: none !important;\n  border-left: none !important;\n  border-right: none !important;\n  border-color: #485156 !important;\n  background-color: transparent !important;\n}\n\n.ant-input:focus,\n.ant-input-focused,\n.ant-select:focus,\n.ant-select-focused,\n.ant-input-number:focus,\n.ant-input-number-focused,\n.ant-input-affix-wrapper:focus,\n.ant-input-affix-wrapper-focused,\n.ant-picker:focus,\n.ant-picker-focused {\n  box-shadow: 0 0 0 2px rgba(0, 168, 74, 0.2) !important;\n  border-radius: 2px;\n}\n\n.ant-input-number:focus,\n.ant-input-number-focused {\n  border: none;\n}\n\n.ant-input-number:hover {\n  box-shadow: 0 0 0 2px rgba(0, 168, 74, 0.2) !important;\n  border: none;\n}\n\n.ant-select-focused:not(.ant-select-disabled).ant-select:not(\n    .ant-select-customize-input\n  )\n  .ant-select-selector {\n  box-shadow: none;\n}\n\n.ant-select,\n.ant-picker {\n  span {\n    color: #637178 !important;\n    opacity: 1;\n  }\n}\n\n.ant-picker-input {\n  input {\n    color: #637178 !important;\n  }\n\n  ::placeholder {\n    color: #637178;\n    opacity: 1;\n  }\n\n  :-ms-input-placeholder {\n    color: #637178;\n  }\n\n  ::-ms-input-placeholder {\n    color: #637178;\n  }\n}\n\n.ant-form-item-control-input {\n  min-height: 0;\n}\n\n.form-dynamic {\n  .ant-form-item {\n    margin-bottom: 10px;\n    width: 100%;\n  }\n\n  .ant-form-item-control-input {\n    display: block !important;\n\n    .ant-form-item-control-input-content {\n      display: flex;\n\n      input {\n        margin-left: 10px;\n      }\n    }\n  }\n}\n\n.document {\n  margin-bottom: 24px;\n  text-align: left;\n\n  h2 {\n    color: #000 !important;\n  }\n\n  h3 {\n    font-size: 14px;\n\n    .required-field {\n      color: #f5222d;\n      font-size: 14px;\n      margin-right: 4px;\n      line-height: 1;\n      font-family: SimSun, sans-serif;\n      content: '*';\n    }\n  }\n}\n\n.ant-form-item {\n  margin-bottom: 5px;\n\n  label {\n    margin-top: 15px !important;\n    color: #000 !important;\n    font-weight: 500 !important;\n    font-size: 14px;\n\n    .required-field {\n      color: #f5222d;\n      font-size: 14px;\n      margin-right: 4px;\n      line-height: 1;\n      font-family: SimSun, sans-serif;\n      content: '*';\n    }\n  }\n\n  input {\n    background-color: transparent;\n  }\n\n  ::placeholder {\n    color: #637178;\n    opacity: 1;\n  }\n\n  :-ms-input-placeholder {\n    color: #637178;\n  }\n\n  ::-ms-input-placeholder {\n    color: #637178;\n  }\n}\n\n.document-form {\n  text-align: left;\n  background-color: #f9f9f9;\n  border-radius: 15px;\n  padding: 15px 12px;\n\n  h3 {\n    margin-top: 15px !important;\n    color: #000 !important;\n    font-weight: 500 !important;\n  }\n\n  h3:first-child {\n    margin-top: 0px !important;\n  }\n\n  div {\n    margin-bottom: 0px;\n  }\n}\n\n.file-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n\n  .ant-form-item {\n    margin: 0 !important;\n  }\n}\n\n.filter {\n  width: 100%;\n  margin-bottom: 30px !important;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  .search-input {\n    width: 40% !important;\n\n    input {\n      height: 45px;\n      border-radius: 6px !important;\n\n      &:focus {\n        --webkit-box-shadow: none !important;\n        box-shadow: none !important;\n      }\n    }\n\n    input::placeholder {\n      color: #485156;\n    }\n\n    span.ant-input-wrapper.ant-input-group {\n      display: flex;\n      flex-direction: row-reverse;\n      align-items: center;\n    }\n\n    .ant-input-group .ant-input {\n      padding-left: 40px;\n      float: left;\n      width: 100%;\n      margin-bottom: 0;\n      z-index: 0;\n      text-align: inherit;\n      background: #f1f3f4 0% 0% no-repeat padding-box !important;\n      border: none !important;\n    }\n\n    button.ant-btn.ant-btn-icon-only.ant-input-search-button {\n      background: transparent;\n      border: none;\n    }\n\n    span.anticon.anticon-search {\n      color: #485156;\n      padding-left: 10px;\n    }\n  }\n}\n\n.ant-spin-dot-item {\n  background-color: #ffbd00 !important;\n}\n\n.ant-form-item-required:before {\n  display: none !important;\n}\n\n.ant-form-item-label\n  > label.ant-form-item-required:not(\n    .ant-form-item-required-mark-optional\n  )::after {\n  display: inline-block;\n  margin-left: 4px;\n  color: #ff0000;\n  font-size: 14px;\n  font-family: SimSun, sans-serif;\n  line-height: 1;\n  content: '*';\n}\n\n.required-field-with-popover {\n  .ant-form-item-required::after {\n    display: none !important;\n  }\n\n  .required {\n    margin-left: -10px;\n  }\n}\n\n.ant-modal-body {\n  overflow: hidden;\n}\n.ant-radio:hover .ant-radio-inner {\n  border-color: $primary-color !important;\n}\n\n.ant-radio-checked .ant-radio-inner,\n.ant-radio-checked::after,\n.ant-checkbox-checked .ant-checkbox-inner {\n  color: $primary-color !important;\n  border-color: $primary-color !important;\n}\n\n.ant-radio-checked .ant-radio-inner::after,\n.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: $primary-color !important;\n}\n\n.ant-radio:hover .ant-radio-inner {\n  border-color: $primary-color !important;\n}\n\n.ant-radio-input:focus + .ant-radio-inner {\n  box-shadow: none !important;\n}\n\n.ant-radio-wrapper:hover .ant-radio,\n.ant-radio:hover .ant-radio-inner,\n.ant-radio-input:focus + .ant-radio-inner {\n  border-color: $primary-color !important;\n}\n\n.ant-modal-content {\n  border-radius: 20px;\n\n  .ant-modal-header {\n    border: none !important;\n    background-color: transparent !important;\n  }\n\n  .ant-modal-footer {\n    display: flex;\n    border: none !important;\n    justify-content: center;\n  }\n}\n\n.ant-modal-content .ant-modal-body {\n  .ant-switch:focus {\n    color: $primary-color;\n    border-color: $primary-color;\n  }\n\n  .ant-btn-primary {\n    background-color: $primary-color;\n    border-color: $primary-color;\n    color: #ffffff !important;\n\n    &:disabled {\n      color: $inactive-button !important;\n      background: #f5f5f5 !important;\n      border: solid 1px $inactive-button !important;\n    }\n  }\n\n  .ant-btn-primary:hover {\n    color: #ffffff;\n    background-color: $hover-primary;\n    border-color: $hover-primary;\n  }\n}\n\n.ant-modal-footer {\n  .ant-btn.ant-btn-primary {\n    color: #ffffff;\n    background-color: $primary-color;\n    border-color: $primary-color;\n  }\n\n  .ant-btn.ant-btn-primary:hover {\n    background-color: $hover-primary;\n    border-color: $hover-primary;\n    color: #ffffff;\n  }\n\n  .ant-btn.ant-btn-primary:focus {\n    color: #ffffff;\n  }\n}\n\n.ant-menu-vertical {\n  border-right: none;\n}\n\n.ant-pagination {\n  .ant-pagination-item-active,\n  .ant-pagination-item-active a,\n  .ant-pagination-item:hover,\n  .ant-pagination-item a:hover,\n  .ant-pagination-item-link:enabled:hover,\n  .ant-pagination-item-container:hover .anticon {\n    color: $primary-color;\n    border-color: $primary-color;\n  }\n}\n\n.ant-picker-range .ant-picker-active-bar {\n  background: transparent !important;\n}\n\n.ant-picker-dropdown {\n  .ant-picker-cell-today .ant-picker-cell-inner::before {\n    border-color: $primary-color;\n  }\n\n  .ant-picker-year-btn:hover,\n  .ant-picker-month-btn:hover {\n    color: $primary-color;\n  }\n\n  .ant-picker-cell-selected .ant-picker-cell-inner {\n    background-color: $primary-color;\n  }\n\n  .ant-picker-footer {\n    .ant-picker-now-btn {\n      color: $primary-color;\n    }\n\n    .ant-btn-primary {\n      color: #ffffff;\n      background-color: $primary-color;\n      border-color: $primary-color;\n    }\n\n    .ant-btn-primary:hover {\n      background-color: $hover-primary;\n      border-color: $hover-primary;\n    }\n  }\n}\n\n.finish-button {\n  display: flex;\n  justify-content: flex-end;\n\n  .ant-btn-primary,\n  .ant-btn {\n    background-color: $primary-color;\n    border-color: $primary-color;\n    color: #ffffff;\n    padding: 10px 30px;\n    border-radius: 5px;\n    height: auto !important;\n    transition: all 100ms ease-in-out;\n    font-weight: bold;\n  }\n\n  .ant-btn-primary:hover,\n  .ant-btn:hover {\n    background-color: $hover-primary !important;\n    border-color: $hover-primary !important;\n    color: #ffffff !important;\n  }\n}\n\n.upload-container {\n  max-height: 45px !important;\n\n  .ant-upload-span,\n  .upload-button {\n    height: 40px !important;\n    margin: 10px 0 !important;\n    border-radius: 50px !important;\n    font-weight: bold;\n    font-size: 16px !important;\n    color: $primary-color !important;\n    border-color: $primary-color !important;\n    display: flex;\n    align-items: center;\n\n    span {\n      margin-left: 2px !important;\n\n      svg {\n        font-size: 20px !important;\n      }\n    }\n  }\n\n  .ant-upload-span {\n    background-color: #ffffff;\n    padding: 0 15px !important;\n    max-height: 40px !important;\n    max-width: 200px !important;\n    border: 1px solid $primary-color;\n    overflow: hidden !important;\n    svg {\n      color: $primary-color;\n    }\n  }\n\n  .ant-upload-list-item {\n    height: 45px !important;\n    margin: 0 !important;\n\n    .ant-upload-text-icon {\n      width: 20px;\n      height: 23px;\n    }\n\n    .ant-upload-list-item-info {\n      padding: 0 !important;\n\n      &:hover {\n        background-color: transparent;\n      }\n\n      .ant-upload-list-item-name {\n        color: $primary-color !important;\n        padding: 0 !important;\n        margin: 0 5px !important;\n\n        &:hover {\n          cursor: pointer;\n          text-decoration: underline;\n        }\n      }\n\n      .ant-upload-list-item-card-actions-btn,\n      .ant-upload-list-item-card-actions {\n        opacity: 1 !important;\n\n        svg {\n          font-size: 16px !important;\n        }\n      }\n\n      .anticon-close {\n        position: relative !important;\n        top: 0 !important;\n        right: 0 !important;\n        opacity: 1 !important;\n      }\n    }\n  }\n\n  .ant-upload-disabled {\n    .upload-button {\n      cursor: not-allowed;\n      color: #e9e9e9 !important;\n      border-color: #e9e9e9 !important;\n\n      svg {\n        color: #e9e9e9 !important;\n      }\n    }\n  }\n}\n\n.ant-tabs-top > .ant-tabs-nav::before {\n  border-bottom: none !important;\n}\n\n.ant-pagination {\n  display: flex !important;\n  justify-content: flex-start !important;\n  margin-top: 15px !important;\n\n  .ant-select-selector,\n  .ant-pagination-item,\n  .ant-pagination-item-link {\n    border-radius: 5px !important;\n  }\n\n  .ant-select-selector {\n    border: 1px solid #d9d9d9 !important;\n  }\n}\n\n.ant-modal-title {\n  font-size: 20px !important;\n}\n\n.ant-form-item-explain-error {\n  color: #ff4d4f !important;\n}\n\n.ant-table-tbody > tr.ant-table-row-selected > td,\n.ant-table-tbody > tr.ant-table-row:hover > td,\n.ant-table-tbody > tr > td.ant-table-cell-row-hover {\n  background-color: #00824113 !important;\n  cursor: pointer;\n}\n\n.ant-checkbox-input:focus + .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner,\n.ant-checkbox-inner {\n  border-color: $primary-color !important;\n}\n\n.ant-checkbox-checked::after {\n  border-color: #0082417c !important;\n}\n\n.ant-notification {\n  z-index: 9999999999 !important;\n}\n\n.ant-row {\n  flex-flow: column !important;\n}\n\n.ant-form-horizontal .ant-form-item-label {\n  text-align: left;\n}\n\n.ant-switch-checked {\n  background-color: $primary-color !important;\n  transition: color 0.8, border 0.8;\n  &:hover {\n    color: $tertiary-color;\n  }\n}\n","$text-color: #464a4e;\n$title-color: #4a4f5d;\n$primary-color: #00a84a;\n$secondary-color: #50b570;\n$tertiary-color: #10a574;\n$quaternary-color: #00a84a;\n$hover-primary: #008241;\n$status-valid: #3cba54;\n$status-invalid: #db3236;\n$status-pending: #f4c20d;\n$status-doubt: #722ed1;\n$active-button: #4295ff;\n$inactive-button: #b7b7b7;\n$background-color: #f1f3f4;\n$black: #000000;\n$white: #ffffff;\n$printerTable-color: #00f26b1a;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
